<template>
  <div class="answer-card">
    <div class="answer-card__icon">✅</div>
    <h2 class="answer-card__title">Correct!</h2>
    <p class="answer-card__sub">Well done - you found the missing letter.</p>

    <!-- countdown ring -->
    <!-- <div class="answer-card__ring-wrap" aria-hidden="true">
      <svg class="answer-card__ring" viewBox="0 0 36 36">
        <circle class="answer-card__ring-bg" cx="18" cy="18" r="15.9" />
        <circle
          class="answer-card__ring-fill"
          cx="18" cy="18" r="15.9"
          :stroke-dashoffset="ringOffset"
        />
      </svg>
      <span class="answer-card__ring-num">{{ countdown }}</span>
    </div> -->
  </div>
</template>

<script>
const DELAY = 0; // seconds before auto-advance

export default {
  data() {
    return {
      countdown: DELAY,
      timer: null,
    };
  },

  computed: {
    // circumference ≈ 100 (using r=15.9); offset goes from 100 → 0
    ringOffset() {
      return (this.countdown / DELAY) * 100;
    },
  },

  mounted() {
    this.timer = setInterval(() => {
      this.countdown -= 1;
      if (this.countdown <= 0) {
        clearInterval(this.timer);
        this.$emit("confirmed");
      }
    }, 1000);
  },

  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>

<style scoped>
.answer-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  padding: 2.5rem 2rem;
  background: var(--color-surface, #fff);
  border: 1px solid #6ee7b7;
  border-radius: var(--radius-lg, 1rem);
  box-shadow: var(--shadow-md, 0 4px 16px rgba(0,0,0,.07));
  text-align: center;
}

.answer-card__icon {
  font-size: 3rem;
  line-height: 1;
  animation: pop-in 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.answer-card__title {
  font-size: 1.8rem;
  font-weight: 800;
  color: #065f46;
  margin: 0;
}

.answer-card__sub {
  font-size: 0.95rem;
  color: #374151;
  margin: 0;
}

/* ── Countdown ring ── */
.answer-card__ring-wrap {
  position: relative;
  width: 52px;
  height: 52px;
  margin-top: 0.5rem;
}

.answer-card__ring {
  width: 100%;
  height: 100%;
  transform: rotate(-90deg); /* start from top */
}

.answer-card__ring-bg {
  fill: none;
  stroke: #d1fae5;
  stroke-width: 3;
}

.answer-card__ring-fill {
  fill: none;
  stroke: #0d9488;
  stroke-width: 3;
  stroke-linecap: round;
  stroke-dasharray: 100;
  transition: stroke-dashoffset 1s linear;
}

.answer-card__ring-num {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.05rem;
  font-weight: 800;
  color: #065f46;
}

@keyframes pop-in {
  from { transform: scale(0.5); opacity: 0; }
  to   { transform: scale(1);   opacity: 1; }
}
</style>
